import { GlobalFiltersState } from '../store/slice/global-filters';

export const buildRequestForDeepestGeoLevel = (filters: GlobalFiltersState) => {
  if (filters.Location?.length) {
    return {
      clients: null,
      companies: null,
      regions: null,
      groups: null,
      locations: filters.Location.map((l) => l.ID),
    };
  }

  if (filters.Group?.length) {
    return {
      clients: null,
      companies: null,
      regions: null,
      groups: filters.Group.map((g) => g.ID),
      locations: null,
    };
  }

  if (filters.Region?.length) {
    return {
      clients: null,
      companies: null,
      regions: filters.Region.map((r) => r.ID),
      groups: null,
      locations: null,
    };
  }

  if (filters.Company?.length) {
    return {
      clients: null,
      companies: filters.Company.map((c) => c.ID),
      regions: null,
      groups: null,
      locations: null,
    };
  }

  if (filters.Client?.length) {
    return {
      clients: filters.Client.map((c) => c.ID),
      companies: null,
      regions: null,
      groups: null,
      locations: null,
    };
  }

  return {
    clients: null,
    companies: null,
    regions: null,
    groups: null,
    locations: null,
  };
};
